import {
	ClassNameProps,
	Column,
	Conditional,
	Else,
	Heading,
	If,
	makeClassName,
	Section,
	StyleProps,
} from "@hex-insights/core";
import { Table } from "@hex-insights/tables";
import { EmptyView } from "../../../../../Components/Empty";
import { Icon } from "../../../../../Components/Icon";
import { StudentEnrollmentsListQuery } from "../../../../../Utilities";
import { CourseSectionFormat, HomeRoomSectionFormat } from "../../../../Format";
import styles from "./styles.module.css";

const columns = ["name", "homeRoomSection"];

const columnWidths = {
	name: "2fr",
};

export type StudentEnrollmentModalContentCourseSectionProps = {
	enrollmentEdges: StudentEnrollmentsListQuery["studentCourseSectionEnrollmentConnection"]["edges"];
} & Partial<ClassNameProps & StyleProps>;

export function StudentEnrollmentModalContentCourseSection({
	enrollmentEdges,
	className,
	style,
}: StudentEnrollmentModalContentCourseSectionProps) {
	return (
		<Section className={makeClassName(styles["section"], className)} style={style}>
			<Section.Header>
				<Heading.H3 noMargin>Courses</Heading.H3>
			</Section.Header>
			<Section.Body style={{ display: "flex", flexDirection: "column" }}>
				<Conditional>
					<If condition={enrollmentEdges.length > 0}>
						<Column justify="spaced-start">
							<Table columns={columns} columnWidths={columnWidths} className={styles["table"]}>
								<Table.Header style={{ position: "static" }}>
									<Table.Row>
										<Table.Heading column="name">Course</Table.Heading>
										<Table.Heading column="homeRoomSection">Home Room</Table.Heading>
									</Table.Row>
								</Table.Header>
								<Table.Body>
									{enrollmentEdges.map(({ node }) => (
										<Table.Row key={node.id}>
											<Table.Cell column="name" oneLine>
												{CourseSectionFormat.name(node.courseSection)}
											</Table.Cell>
											<Table.Cell column="homeRoomSection" oneLine className={styles["table__cell--home-room-section"]}>
												{node.courseSection.homeRoomSection
													? HomeRoomSectionFormat.name(node.courseSection.homeRoomSection)
													: null}
											</Table.Cell>
										</Table.Row>
									))}
								</Table.Body>
							</Table>
						</Column>
					</If>
					<Else>
						<EmptyView
							IconComponent={Icon.Chalkboard}
							iconSize={48}
							primaryText="Courses"
							secondaryText="This student is not enrolled in any courses this term."
						/>
					</Else>
				</Conditional>
			</Section.Body>
		</Section>
	);
}
